const state = {
    itemuom: [],
    itemuomId: [],
    loading: false
};

export default state;